import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router";
import { Item } from "@/types/fse";

interface Props {
  onAccept: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  item: Item;
}

export const ChronologyFolderRegenerateModal: React.FC<Props> = ({ item, isOpen, setIsOpen, onAccept }) => {
  const navigate = useNavigate();

  const handleAccept = () => {
    onAccept();
    setIsOpen(false);
  };

  const handleCancel = () => {
    navigate(`/chronology/${item.id}`);

    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Warning</DialogTitle>
        </DialogHeader>
        <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
          <p className="text-md my-2 text-gray-500">
            Chronologies already exist for some files in this folder, do you wish to proceed?
          </p>
        </div>
        <div className="mt-4 flex justify-between">
          <Button variant="outline" onClick={handleCancel} type="button">
            No, show existing
          </Button>

          <Button onClick={handleAccept} type="button">
            Proceed
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
